import { differenceInMinutes, formatDistance } from "date-fns";
import Swal from "sweetalert2";

export const handleJoinMeeting = (item, userId, showAlert = true, navigate) => {
  const date = new Date(item?.timeSlot.startTime);
  const currentTime = new Date();
  const timeDifference = differenceInMinutes(date, currentTime);

  const timeDifferenceFormat = formatDistance(date, currentTime, {
    includeSeconds: false,
  });

  console.log(timeDifference);

  console.log("userId", userId);

  if (timeDifference <= 15 && timeDifference > -90) {
    navigate.push(
      `/dashboard/video-chat?roomId=${item._id}&&name=${userId}&&callType=${item?.chatRoomId?.chatRoomType}`
    );
    return true;
  } else if (timeDifference < -90) {
    showAlert &&
      Swal.fire({
        titleText: `Oops! Meeting time is over`,
        icon: "error",
        showConfirmButton: false,
      });
    return false;
  } else {
    showAlert &&
      Swal.fire({
        titleText: `Oops! You can join consultation  
            15 minutes before the starting time, 
             ${timeDifferenceFormat} remaining
            `,
        icon: "error",
      });
    return false;
  }
};
